import setEditStateAction from './setEditStateAction';
import { getErrorFromObject } from '../../logging/genericInformationLogging';
import getWacInfoForSharePointFile from '../../services/getWacInfoForSharePointFile';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import { EditMode, getSxSViewStore } from 'owa-group-files-hub-store';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import strings from 'owa-strings/owa-mail-strings';
import { lazySetPreviewError, lazySetPreviewLoading, lazySetWacPreviewState } from 'owa-sxsdata';
import { action, orchestrator } from 'satcheljs';

export const editWacFileAction = action('editWacFileAction', (fileId: string) => ({ fileId }));

orchestrator(editWacFileAction, msg => {
    editWacFileOrchestrator(msg.fileId);
});

async function editWacFileOrchestrator(fileId: string) {
    const datapoint = new PerformanceDatapoint('GroupFilesHubEditWacFileActionDP');

    const store = getSxSViewStore();

    try {
        datapoint.addCheckmark('getWacInfoForSharePointFileStart');
        const getWacInfoPromise = getWacInfoForSharePointFile(
            store.wacFileEditState.fileUrl,
            AttachmentDataProviderType.OneDrivePro,
            'EditWacFile',
            true
        );
        const setPreviewLoading = await lazySetPreviewLoading.import();
        setPreviewLoading(
            store.viewState,
            '' // Loading message. When it is empty we just show a spinner.
        );
        const setWacPreviewState = await lazySetWacPreviewState.import();
        datapoint.addCheckmark('lazyImportSetPreviewStateFuncDone');
        const wacUrl = await getWacInfoPromise;
        datapoint.addCheckmark('getWacInfoForSharePointFileDone');

        if (wacUrl) {
            if (store.viewState.previewPane.id == fileId) {
                // There is work in progress to support a new approach to opening the WAC for SharePoint files.
                // This code will continue to use the old approach for now.
                // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/36830
                setWacPreviewState(
                    store.viewState,
                    wacUrl,
                    null, // Consumer OneDrive token
                    new Date().getTime(),
                    null, // Boot Script URL
                    null, // Wopi Src URL
                    null, // Access Token
                    null, // File Name
                    0, // File Size
                    false, // useJsApi
                    null, // File get URL
                    null, // Bundle info
                    store.viewState.previewPane
                );
                setEditStateAction(EditMode.Edit);
                datapoint.addCustomProperty('userEnteredEditMode', true);
            } else {
                // User closes preview pane before we get edit url.
                datapoint.addCustomProperty('userEnteredEditMode', false);
            }

            datapoint.end();
        } else {
            const error = new Error('WAC url is not valid.');
            handleEditWacFailure(error, datapoint);
        }
    } catch (error) {
        handleEditWacFailure(error, datapoint);
    }
}

async function handleEditWacFailure(error: Error, datapoint: PerformanceDatapoint) {
    const setPreviewError = await lazySetPreviewError.import();
    setPreviewError(getSxSViewStore().viewState, strings.errorGetWacUrl);
    setEditStateAction(EditMode.View);
    datapoint.endWithError(DatapointStatus.ServerError, getErrorFromObject(error));
}
